import { Link } from "react-router-dom";

function Footer(props) {
  return (
    <div className="h-12 bg-indigo-500 flex justify-start items-center">
      <div className="text-white text-sm px-4">
        <Link to="/help">
          <span className="">Help</span>
        </Link>
        <span className="mx-2">|</span>

        <Link to="/tou">
          <span className="">Terms of Service</span>
        </Link>
      </div>
    </div>
  );
}

export default Footer;
